import { cdnImageUrl } from 'helpers/image'
import { useService } from 'services/utils/context'
import Story from 'store/entities/Story/Story.store'

export const useTransparentBrandLogo = (
  story: Story | null,
  imgSize: number,
) => {
  const service = useService()

  const hasTransparentLogo = story && story.headerImageBrandId
  if (!hasTransparentLogo) {
    return undefined
  }

  const logoBrand = hasTransparentLogo
    ? service.brands.getByBrandId(story!.headerImageBrandId!)
    : undefined

  const transparentBrandLogoHash = logoBrand
    ? logoBrand.transparentImageHash
    : null

  return transparentBrandLogoHash
    ? cdnImageUrl(transparentBrandLogoHash, {
        width: imgSize,
        transparent: true,
        trim: true,
      })
    : undefined
}
